import { Routes, Route } from "react-router-dom";

import Container from "react-bootstrap/Container";

import Header from "./Header";
import Footer from "./Footer";
import Offseason from "./Offseason";
import Current from "./Current";
import DC34 from "./DC34";
import LastMonth from "./LastMonth";
import Subscribers from "./Subscribers";

import "./App.css";

/*
TODO:
* select marker to highlight
* filter by time
* cluster by time
* pull from influx
*/

function App() {
  return (
    <>
      <Header />
      <Container fluid>
        <Routes>
          <Route
            index
            path="/"
            element={
              <Offseason />
            }
          />
          {/* Unlinked — live tracking, only interesting during the con */}
          <Route
            index
            path="/current"
            element={
              <Current />
            }
          />
          <Route
            index
            path="/dc34"
            element={
              <DC34 />
            }
          />
          <Route
            index
            path="/lastmonth"
            element={
              <LastMonth/>
            }
          />
          <Route
            path="/subscribers"
            element={
              <Subscribers />
            }
          />

        </Routes>
      </Container>
      <Footer />
    </>
  );
}

export default App;
